<template>
  <v-card style="height: 100%">
    <project-flow-navigation-toolbar
      :title="buildingName"
    ></project-flow-navigation-toolbar>

    <v-toolbar dark dense>
      <v-tabs v-model="tab">
        <v-tab href="#details"> Details </v-tab>
        <v-tab href="#media"> Media </v-tab>
        <v-tab href="#pois"> Points of interest </v-tab>
        <v-tab href="#apartmentTypes"> Apartment Types </v-tab>
        <v-tab href="#apartmentOrientations"> Apartment Orientations </v-tab>
        <v-tab href="#apartments"> Apartments </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items
      style="height: calc(100% - 112px); position: relative"
      v-model="tab"
    >
      <v-tab-item style="height: 100%" value="details">
        <v-card class="full-height-card">
          <v-card-text>
            <v-row>
              <v-col class="mt-4" cols="12" sm="6" md="4">
                <v-text-field
                  dense
                  v-model="building.name"
                  label="Name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-card-title>
                {{
                  `Building is: ${
                    building.publish ? 'published' : 'unpublished'
                  }`
                }}
              </v-card-title>
              <v-card-text>
                <v-switch
                  inset
                  hide-details="auto"
                  class="mt-0 ml-1"
                  v-model="building.publish"
                  :disabled="checkboxDisabled"
                >
                </v-switch>
              </v-card-text>
            </v-row>
            <v-row>
              <v-col
                :v-if="building.properties"
                v-for="(item, key) in building.properties"
                :key="key"
                cols="2"
                sm="2"
                md="2"
              >
                <v-text-field
                  outlined
                  dense
                  v-model="building.properties[key]"
                  :label="key"
                ></v-text-field>
              </v-col>
            </v-row>
            <!-- <v-row>
                <v-dialog v-model="dialog" max-width="500px" persistent>
                  <template v-slot:activator="{ on }">
                    <v-btn color="blue darken-1" v-on="on">Add new field</v-btn>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="newFieldName"
                              label="Field name"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              v-model="newFieldDefaultValue"
                              label="Default value"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="blue darken-1"
                        text
                        @click="closeNewFieldDialog"
                        >Cancel</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="saveNewField"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row> -->
          </v-card-text>
          <v-spacer />
          <v-card-actions>
            <v-btn color="red darken-1" @click="deleteBuilding">Delete</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              :disabled="saveButtonDisabled"
              @click="save"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item value="media">
        <media
          v-if="showMedia"
          :media="this.$store.state.MediaStore.media"
        ></media>
        <v-card-subtitle v-if="!showMedia"
          >There is no default poi for this record, media is not available.
        </v-card-subtitle>
      </v-tab-item>
      <v-tab-item value="pois">
        <v-list-item>
          <v-list-item-content>
            <poi-list
              :poi-list="this.$store.state.PoiStore.pois"
              parentType="building"
              :parent="this.$store.state.BuildingStore.selectedBuilding"
            ></poi-list>
          </v-list-item-content>
        </v-list-item>
      </v-tab-item>
      <v-tab-item value="apartmentTypes">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-list-item>
              <v-list-item-content>
                <apartment-type-list
                  :apartmentTypeList="
                    this.$store.state.ApartmentTypeStore.apartmentTypes
                  "
                ></apartment-type-list>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="apartmentOrientations">
        <v-card flat>
          <v-card-text class="pa-0">
            <v-list-item>
              <v-list-item-content>
                <apartment-orientation-list
                  :apartmentOrientationList="
                    this.$store.state.ApartmentOrientationStore
                      .apartmentOrientations
                  "
                ></apartment-orientation-list>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="apartments">
        <v-list-item>
          <v-list-item-content>
            <apartment-list
              :apartmentList="this.$store.state.ApartmentStore.apartments"
            ></apartment-list>
          </v-list-item-content>
        </v-list-item>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ApartmentList from '../../components/RecordLists/ApartmentList'
import ApartmentTypeList from '../../components/RecordLists/ApartmentTypeList'
import ApartmentOrientationList from '../../components/RecordLists/ApartmentOrientationList'
import ProjectFlowNavigationToolbar from '../../components/AppBar/ProjectFlowNavigationToolbar'
import Enums from '../../helpers/Enums'
import Media from '../../views/Media'
import PoiList from '../../components/RecordLists/PoiList'
import { mapState } from 'vuex'
import MasterplanService from '../../services/MasterplanService'

export default {
  name: 'BuildingExplore',
  props: {},
  components: {
    ApartmentList,
    ApartmentTypeList,
    // eslint-disable-next-line vue/no-unused-components
    ApartmentOrientationList,
    ProjectFlowNavigationToolbar,
    Media,
    PoiList
  },
  data: function() {
    return {
      pois: [],
      building: {},
      title: '',
      tab: null,
      changeDetected: false,
      newFieldName: '',
      newFieldDefaultValue: null,
      dialog: false,
      showMedia: false,
      checkboxDisabled: false
    }
  },
  computed: {
    buildingName: function() {
      return this.$store.state.BuildingStore.selectedBuilding
        ? this.$store.state.BuildingStore.selectedBuilding.name
        : ''
    },
    saveButtonDisabled: function() {
      return !this.changeDetected
    },
    ...mapState('MediaStore', ['selectedGallery'])
  },
  watch: {
    selectedGallery: async function(newValue) {
      await this.$store.dispatch('MediaStore/fetchMedia')
    },
    building: {
      // This will let Vue know to look inside the object
      deep: true,
      handler: function(after, before) {
        if (
          JSON.stringify(before) !== '{}' &&
          JSON.stringify(this.building) !==
            JSON.stringify(this.$store.state.BuildingStore.selectedBuilding)
        ) {
          this.changeDetected = true
        }
      }
    }
  },
  methods: {
    getData: async function(buildingId, masterplanId) {
      if (buildingId) {
        await this.$store.dispatch('MediaStore/resetStore')

        await this.$store.dispatch(
          'BuildingStore/setSelectedBuilding',
          buildingId
        )
        this.building = JSON.parse(
          JSON.stringify(this.$store.state.BuildingStore.selectedBuilding)
        )
        const masterplan = await MasterplanService.getMasterplanById(
          masterplanId
        )
        if (!masterplan.data.publish) {
          this.checkboxDisabled = true
        }
        await this.$store.dispatch('ApartmentStore/fetchApartments', {
          root: true
        })
        await this.$store.dispatch('ApartmentTypeStore/fetchApartmentTypes', {
          root: true
        })
        await this.$store.dispatch(
          'ApartmentOrientationStore/fetchApartmentOrientations',
          {
            root: true
          }
        )

        await this.$store.dispatch('PoiStore/setPoiContext', 'building')
        await this.$store.dispatch('PoiStore/fetchPois')

        // find default poi
        let defaultPoi = this.$store.state.PoiStore.pois.find(el => {
          return el.poiTypeId === Enums.PoiType.poi_type_building
        })
        if (defaultPoi) {
          await this.$store.dispatch('PoiStore/setSelectedPoi', defaultPoi.id)
          await this.$store.dispatch('MediaStore/setMediaContext', 'poi')
          await this.$store.dispatch('MediaStore/fetchMediaTypes')
          await this.$store.dispatch('MediaStore/fetchMedia')
          this.showMedia = true
        } else {
          this.showMedia = false
        }
      }
    },
    save: async function() {
      await this.$store.dispatch('BuildingStore/updateBuilding', this.building)
      // Upisivanje updateovanog buildinga se sada izvrsava u updateBuilding akciji:
      // await this.$store.dispatch(
      //   'BuildingStore/setSelectedBuilding',
      //   this.$route.params.buildingId
      // )
      this.building = JSON.parse(
        JSON.stringify(this.$store.state.BuildingStore.selectedBuilding)
      )
      this.changeDetected = false
    },
    saveNewField: function() {
      let self = this
      if (!this.building.properties) this.building.properties = {}
      if (this.building.properties.hasOwnProperty(this.newFieldName)) {
        this.$store.dispatch(
          'NotificationStore/add',
          {
            type: 'error',
            message: `The field with the given name already exists.`
          },
          { root: true }
        )
      } else {
        this.building.properties[self.newFieldName] = self.newFieldDefaultValue
      }
      this.closeNewFieldDialog()
    },
    closeNewFieldDialog: function() {
      this.newFieldName = ''
      this.newFieldDefaultValue = null
      this.dialog = false
    },
    deleteBuilding: async function() {
      this.$confirm({
        title: 'Delete Building',
        text: 'Are you sure?',
        acceptText: 'DELETE',
        cancelText: 'CANCEL'
      })
        .then(y => {
          this.$store
            .dispatch(
              'BuildingStore/deleteBuilding',
              this.$route.params.buildingId
            )
            .then(
              () => {
                this.$router.go(-1)
                this.$emit('deleted')
              },
              err => {
                this.$store.dispatch(
                  'NotificationStore/add',
                  {
                    type: 'error',
                    message: 'Building has child records, it cannot be deleted.'
                  },
                  { root: true }
                )
              }
            )
        })
        .catch(n => {
          console.log('NO')
        })
    }
  },
  created: async function() {
    // if (localStorage.exploreBuildingActiveTab) {
    //   this.tab = localStorage.exploreBuildingActiveTab
    // }
    let lastBreadcrumb = this.$store.state.BreadcrumbsStore.history[
      this.$store.state.BreadcrumbsStore.history.length - 2
    ]
    if (lastBreadcrumb && lastBreadcrumb.tab) {
      if (lastBreadcrumb.tab === 'APARTMENT ') {
        this.tab = 'apartments'
      }
      if (lastBreadcrumb.tab === 'APARTMENT TYPE ') {
        this.tab = 'apartmentTypes'
      }
      if (lastBreadcrumb.tab === 'P.O.I ') {
        this.tab = 'pois'
      }
    }
  },
  mounted: function() {},

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getData(
        parseInt(to.params.buildingId),
        parseInt(to.params.masterplanId)
      )
    })
  },
  async beforeRouteUpdate(to, from, next) {
    this.getData(to.params.buildingId, to.params.masterplanId)
    next()
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name == 'Explore Poi' ||
      to.name == 'Explore Apartment Type' ||
      to.name == 'Explore Apartment'
    ) {
      localStorage.exploreBuildingActiveTab = this.tab
    } else {
      localStorage.exploreBuildingActiveTab = 'details'
    }
    next()
  }
}
</script>

<style scoped></style>
